module.exports = __webpack_public_path__ + "img/page.11f51a03.png";